import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import UtilSequence from "@/utils/UtilSequence.mjs";
import UtilDateTime from "@/utils/UtilDateTime";

const CONTA_FINANCEIRA_BANCO_ITAU_DELTA_DUCON_ID = "ac2572c4-5738-4858-a228-49bcb9a884eb";

export default {

    async criarPagamentosDeContasAPagar(pagamentosValores = []){

        let pagamentos = {
            data: [],
            status: 200
        };

        try{

            pagamentos.data = await UtilSequence.each({
                list: pagamentosValores,
                callback: async (pagamentoValores)=>{

                    let pagamento = {};
                    let pagamentoTipo = pagamentoValores?.tipo;

                    if(pagamentoTipo == "Pagamento de Adiantamento"){

                        pagamento = await this.criarPagamentoDeAdiantamento(pagamentoValores);
                        if(pagamento.status != 200){
                            throw pagamento;
                        }

                        return pagamento.data;
                        
                    }

                    if(pagamentoTipo == "Pagamento de Nota Fiscal Recebida"){

                        pagamento = await this.criarPagamentoDeNotaFiscalRecebida(pagamentoValores);
                        if(pagamento.status != 200){
                            throw pagamento;
                        }

                        return pagamento.data;
                        
                    }

                    if(pagamentoTipo == "Pagamento com Vinculo de Adiantamento"){

                        pagamento = await this.criarPagamentoDeVinculoDeAdiantamento(pagamentoValores);
                        if(pagamento.status != 200){
                            throw pagamento;
                        }

                        return pagamento.data;
                        
                    }

                    // Se não encontrar o Tipo do Pagamento assuma Erro. 
                    pagamento.status = 500;
                    pagamento.message = "Tipo do Pagamento Invalido";
                    throw pagamento;

                }
            });

        }catch(e){

            console.log(e);
            pagamentos.status = 500;
            return pagamentos;

        }

        return pagamentos;

    },    
    
    async criarPagamentoDeAdiantamento(pagamentoValores = []){

        let pagamento = {};

        try{

            pagamentoValores = {
                tipo: pagamentoValores?.tipo || "Pagamento Invalido",
                contaAPagar: pagamentoValores.contaAPagar || null,
                valorPagamento: pagamentoValores?.valorPagamento || 0,
                valorReservado: pagamentoValores?.valorReservado || 0,
            }

            //==================================================================//
            //==================== Pega a Conta a Pagar ========================//
            //==================================================================//

            let contaAPagarID = pagamentoValores?.contaAPagar;

            let contaAPagar = await ERP.getOneById(Schema.CONTAS_A_PAGAR, contaAPagarID);
            if(contaAPagar.status != 200){
                throw contaAPagar;
            }

            contaAPagar.data.valorParaReservar = contaAPagar.data.valorParaReservar - pagamentoValores.valorReservado;

            contaAPagar.data.valorPagamento = contaAPagar.data.valorPagamento + pagamentoValores.valorPagamento;
            contaAPagar.data.valorReservado = contaAPagar.data.valorReservado + pagamentoValores.valorReservado;
            contaAPagar.data.valorParaPagar = contaAPagar.data.valorParaPagar + pagamentoValores.valorPagamento;

            contaAPagar.data.pagamentos = contaAPagar?.data?.pagamentos || [];

            //==================================================================//
            //====== Pega Próxima Sequencia do Pagamento da Conta a Pagar ======//
            //==================================================================//

            let pagamentoSequencia = await ERP.getNextSequence({
                parentSchema: Schema.CONTAS_A_PAGAR,
                parentID: contaAPagarID,
                relationSchema: Schema.CONTAS_A_PAGAR_PAGAMENTOS,
                relationField: "pagamentos",
                sequenceField: "sequencia",
                sequenceFill: 5,
            });
            if(pagamentoSequencia.status != 200){
                throw pagamentoSequencia
            }

            //==================================================================//
            //=============== Criar Pagamento da Conta a Paga ==================//
            //==================================================================//

            pagamentoValores = {
                sequencia: pagamentoSequencia.data.value,
                tipo: pagamentoValores?.tipo,
                status: "Pagamento não realizado",
                contaAPagar: contaAPagarID,
                dataCriacao: UtilDateTime.todayUTC(),
                dataVencimento: UtilDateTime.toFormatUTC({dateTime:contaAPagar?.data?.dataVencimento}),
                valorDesconto: 0,
                valorPagamento: pagamentoValores?.valorPagamento,
                valorReservado: pagamentoValores?.valorReservado,
                valorParaPagar: pagamentoValores?.valorPagamento,
                valorPago: 0,
                valorParaVincular: 0,
                valorVinculado: 0,
            }

            pagamento = await ERP.postOne(Schema.CONTAS_A_PAGAR_PAGAMENTOS, pagamentoValores);
            if(pagamento.status != 200){
                throw pagamento;
            }

            console.log(pagamento);

            contaAPagar.data.pagamentos.push(pagamento?.data?.id);

            //==================================================================//
            //=================== Altera a Conta a Pagar =======================//
            //==================================================================//

            let contaAPagarValores = {
                id: contaAPagarID,
                valorParaReservar: contaAPagar.data.valorParaReservar,
                valorPagamento: contaAPagar.data.valorPagamento,
                valorReservado: contaAPagar.data.valorReservado,
                valorParaPagar: contaAPagar.data.valorParaPagar,
                pagamentos: contaAPagar.data.pagamentos,
            }

            contaAPagar = await ERP.patchOne(Schema.CONTAS_A_PAGAR, contaAPagarValores);
            if(contaAPagar.status != 200){
                throw contaAPagar;
            }

            console.log(contaAPagar);

        }catch(e){

            console.log(e);
            return pagamento;

        }

        return pagamento;

    },

    async criarPagamentoDeNotaFiscalRecebida(pagamentoValores = []){

        let pagamento = {};

        try{

            pagamentoValores = {
                tipo: pagamentoValores?.tipo || "Pagamento Invalido",
                notaFiscalRecebida: pagamentoValores?.notaFiscalRecebida || null,
                contaAPagar: pagamentoValores.contaAPagar || null,
                valorDesconto: pagamentoValores?.valorDesconto || 0,
                valorPagamento: pagamentoValores?.valorPagamento || 0,
                valorReservado: pagamentoValores?.valorReservado || 0,
            }

            //==================================================================//
            //==================== Pega a Conta a Pagar ========================//
            //==================================================================//

            let contaAPagarID = pagamentoValores?.contaAPagar;

            let contaAPagar = await ERP.getOneById(Schema.CONTAS_A_PAGAR, contaAPagarID);
            if(contaAPagar.status != 200){
                throw contaAPagar;
            }

            contaAPagar.data.valorParaReservar = contaAPagar.data.valorParaReservar - pagamentoValores.valorReservado;

            contaAPagar.data.valorPagamento = contaAPagar.data.valorPagamento + pagamentoValores.valorPagamento;
            contaAPagar.data.valorDesconto = contaAPagar.data.valorDesconto + pagamentoValores.valorDesconto;
            contaAPagar.data.valorReservado = contaAPagar.data.valorReservado + pagamentoValores.valorReservado;
            contaAPagar.data.valorParaPagar = contaAPagar.data.valorParaPagar + pagamentoValores.valorPagamento;

            contaAPagar.data.pagamentos = contaAPagar?.data?.pagamentos || [];

            //==================================================================//
            //====== Pega Próxima Sequencia do Pagamento da Conta a Pagar ======//
            //==================================================================//

            let pagamentoSequencia = await ERP.getNextSequence({
                parentSchema: Schema.CONTAS_A_PAGAR,
                parentID: contaAPagarID,
                relationSchema: Schema.CONTAS_A_PAGAR_PAGAMENTOS,
                relationField: "pagamentos",
                sequenceField: "sequencia",
                sequenceFill: 5,
            });
            if(pagamentoSequencia.status != 200){
                throw pagamentoSequencia
            }

            //==================================================================//
            //=============== Criar Pagamento da Conta a Paga ==================//
            //==================================================================//

            pagamentoValores = {
                sequencia: pagamentoSequencia.data.value,
                tipo: pagamentoValores?.tipo,
                status: "Pagamento não realizado",
                contaAPagar: contaAPagarID,
                notaFiscalRecebida: pagamentoValores?.notaFiscalRecebida,
                dataCriacao: UtilDateTime.todayUTC(),
                dataVencimento: UtilDateTime.toFormatUTC({dateTime:contaAPagar?.data?.dataVencimento}),
                valorDesconto:  pagamentoValores?.valorDesconto,
                valorPagamento: pagamentoValores?.valorPagamento,
                valorReservado: pagamentoValores?.valorReservado,
                valorParaPagar: pagamentoValores?.valorPagamento,
                valorPago: 0,
                valorParaVincular: 0,
                valorVinculado: 0,
            }

            pagamento = await ERP.postOne(Schema.CONTAS_A_PAGAR_PAGAMENTOS, pagamentoValores);
            if(pagamento.status != 200){
                throw pagamento;
            }

            console.log(pagamento);

            contaAPagar.data.pagamentos.push(pagamento?.data?.id);

            //==================================================================//
            //=================== Altera a Conta a Pagar =======================//
            //==================================================================//

            let contaAPagarValores = {
                id: contaAPagarID,
                valorParaReservar: contaAPagar.data.valorParaReservar,
                valorDesconto: contaAPagar.data.valorDesconto,
                valorPagamento: contaAPagar.data.valorPagamento,
                valorReservado: contaAPagar.data.valorReservado,
                valorParaPagar: contaAPagar.data.valorParaPagar,
                pagamentos: contaAPagar.data.pagamentos,
            }

            contaAPagar = await ERP.patchOne(Schema.CONTAS_A_PAGAR, contaAPagarValores);
            if(contaAPagar.status != 200){
                throw contaAPagar;
            }

            console.log(contaAPagar);

            //==================================================================//
            //================== Pega a Nota Fiscal Recebida ===================//
            //==================================================================//

            let notaFiscalRecebidaID = pagamento.data.notaFiscalRecebida;

            let notaFiscalRecebida = await ERP.getOneById(Schema.NOTA_FISCAL_RECEBIDA, notaFiscalRecebidaID);
            if(notaFiscalRecebida.status != 200){
                throw notaFiscalRecebida;
            }

            notaFiscalRecebida.data.valorParaReservar = notaFiscalRecebida.data.valorParaReservar - pagamento.data.valorReservado;

            notaFiscalRecebida.data.valorPagamento = notaFiscalRecebida.data.valorPagamento + pagamento.data.valorPagamento;
            notaFiscalRecebida.data.valorDesconto = notaFiscalRecebida.data.valorDesconto + pagamento.data.valorDesconto;
            notaFiscalRecebida.data.valorReservado = notaFiscalRecebida.data.valorReservado + pagamento.data.valorReservado;
            notaFiscalRecebida.data.valorParaPagar = notaFiscalRecebida.data.valorParaPagar + pagamento.data.valorPagamento;

            //==================================================================//
            //================ Altera a Nota Fiscal Recebida ===================//
            //==================================================================//

            let notaFiscalRecebidaValores = {
                id: notaFiscalRecebidaID,
                valorParaReservar: notaFiscalRecebida.data.valorParaReservar,
                valorDesconto: notaFiscalRecebida.data.valorDesconto,
                valorPagamento: notaFiscalRecebida.data.valorPagamento,
                valorReservado: notaFiscalRecebida.data.valorReservado,
                valorParaPagar: notaFiscalRecebida.data.valorParaPagar,
            }

            notaFiscalRecebida = await ERP.patchOne(Schema.NOTA_FISCAL_RECEBIDA, notaFiscalRecebidaValores);
            if(notaFiscalRecebida.status != 200){
                throw notaFiscalRecebida;
            }

            console.log(notaFiscalRecebida);

        }catch(e){

            console.log(e);
            return pagamento;

        }

        return pagamento;

    },

    async criarPagamentoDeVinculoDeAdiantamento(pagamentoValores = []){

        let pagamento = {};

        try{

            pagamentoValores = {
                tipo: pagamentoValores?.tipo || "Pagamento Invalido",
                adiantamento: pagamentoValores?.adiantamento || null,
                contaAPagar: pagamentoValores.contaAPagar || null,
                valorPagamento: pagamentoValores?.valorPagamento || 0,
                valorReservado: pagamentoValores?.valorReservado || 0,
            }

            //==================================================================//
            //==================== Pega a Conta a Pagar ========================//
            //==================================================================//

            let contaAPagarID = pagamentoValores?.contaAPagar;

            let contaAPagar = await ERP.getOneById(Schema.CONTAS_A_PAGAR, contaAPagarID);
            if(contaAPagar.status != 200){
                throw contaAPagar;
            }

            contaAPagar.data.valorParaReservar = contaAPagar.data.valorParaReservar - pagamentoValores.valorReservado;

            contaAPagar.data.valorPagamento = contaAPagar.data.valorPagamento + pagamentoValores.valorPagamento;
            contaAPagar.data.valorReservado = contaAPagar.data.valorReservado + pagamentoValores.valorReservado;

            contaAPagar.data.pagamentos = contaAPagar?.data?.pagamentos || [];

            //==================================================================//
            //====== Pega Próxima Sequencia do Pagamento da Conta a Pagar ======//
            //==================================================================//

            let pagamentoSequencia = await ERP.getNextSequence({
                parentSchema: Schema.CONTAS_A_PAGAR,
                parentID: contaAPagarID,
                relationSchema: Schema.CONTAS_A_PAGAR_PAGAMENTOS,
                relationField: "pagamentos",
                sequenceField: "sequencia",
                sequenceFill: 5,
            });
            if(pagamentoSequencia.status != 200){
                throw pagamentoSequencia
            }

            //==================================================================//
            //=============== Criar Pagamento da Conta a Paga ==================//
            //==================================================================//

            pagamentoValores = {
                sequencia: pagamentoSequencia.data.value,
                tipo: pagamentoValores?.tipo,
                status: "Pagamento Realizado",
                contaAPagar: contaAPagarID,
                adiantamento: pagamentoValores?.adiantamento,
                dataCriacao: UtilDateTime.todayUTC(),
                dataVencimento: UtilDateTime.toFormatUTC({dateTime:contaAPagar?.data?.dataVencimento}),
                valorDesconto:  0,
                valorPagamento: pagamentoValores?.valorPagamento,
                valorReservado: pagamentoValores?.valorReservado,
                valorParaPagar: 0,
                valorPago: 0,
                valorParaVincular: 0,
                valorVinculado: 0,
            }

            pagamento = await ERP.postOne(Schema.CONTAS_A_PAGAR_PAGAMENTOS, pagamentoValores);
            if(pagamento.status != 200){
                throw pagamento;
            }

            console.log(pagamento);

            contaAPagar.data.pagamentos.push(pagamento?.data?.id);

            //==================================================================//
            //========= Determina se a Conta a Pagar foi Realizada =============//
            //==================================================================//

            if(
                contaAPagar.data.valorParaReservar === 0 &&
                contaAPagar.data.valorParaPagar === 0
            ){

                contaAPagar.data.status = "Realizada"

            }

            //==================================================================//
            //=================== Altera a Conta a Pagar =======================//
            //==================================================================//

            let contaAPagarValores = {
                id: contaAPagarID,
                status: contaAPagar.data.status,
                valorParaReservar: contaAPagar.data.valorParaReservar,
                valorPagamento: contaAPagar.data.valorPagamento,
                valorReservado: contaAPagar.data.valorReservado,
                pagamentos: contaAPagar.data.pagamentos,
            }

            contaAPagar = await ERP.patchOne(Schema.CONTAS_A_PAGAR, contaAPagarValores);
            if(contaAPagar.status != 200){
                throw contaAPagar;
            }

            console.log(contaAPagar);

            //==================================================================//
            //====================== Pega o Adiantamento =======================//
            //==================================================================//

            let adiantamentoID = pagamento.data.adiantamento;

            let adiantamento = await ERP.getOneById(Schema.CONTAS_A_PAGAR, adiantamentoID);
            if(adiantamento.status != 200){
                throw adiantamento;
            }

            adiantamento.data.valorParaVincular = adiantamento.data.valorParaVincular - pagamento.data.valorReservado;

            adiantamento.data.valorVinculado = adiantamento.data.valorVinculado + pagamento.data.valorPagamento;

            //==================================================================//
            //========== Determina se o Adiantamento foi Realizada =============//
            //==================================================================//

            if(
                adiantamento.data.valorParaReservar === 0 &&
                adiantamento.data.valorParaPagar === 0 &&
                adiantamento.data.valorParaVincular === 0
            ){

                adiantamento.data.status = "Realizada"

            }

            //==================================================================//
            //==================== Altera o Adiantamento =======================//
            //==================================================================//

            let adiantamentoValores = {
                id: adiantamentoID,
                status: adiantamento.data.status,
                valorParaVincular: adiantamento.data.valorParaVincular,
                valorVinculado: adiantamento.data.valorVinculado,
            }

            adiantamento = await ERP.patchOne(Schema.CONTAS_A_PAGAR, adiantamentoValores);
            if(adiantamento.status != 200){
                throw adiantamento;
            }

            console.log(adiantamento);

        }catch(e){

            console.log(e);
            return pagamento;

        }

        return pagamento;

    },

    async baixarPagamentosDeContasAPagar(pagamentosValores = []){

        let pagamentos = {
            data: [],
            status: 200
        };

        try{

            pagamentos.data = await UtilSequence.each({
                list: pagamentosValores,
                callback: async (pagamentoValores)=>{

                    //==================================================================//
                    //========================= Pega Pagamento =========================//
                    //==================================================================//

                    let pagamentoID = pagamentoValores?.id;

                    let pagamento = await ERP.getOneById(Schema.CONTAS_A_PAGAR_PAGAMENTOS, pagamentoID);
                    if(pagamento.status != 200){
                        throw pagamento;
                    }

                    //==================================================================//
                    //==================== Monta Pagamento Valores =====================//
                    //==================================================================//

                    pagamentoValores = {
                        id: pagamentoID,
                        valorParaPagar: pagamento.data.valorParaPagar || 0,
                    }

                    //==================================================================//
                    //================== Requisita Tipo de Pagamento ===================//
                    //==================================================================//

                    if(pagamento.data.tipo == "Pagamento de Adiantamento"){

                        pagamento = await this.baixarPagamentoDeAdiantamento(pagamentoValores);
                        if(pagamento.status != 200){
                            throw pagamento;
                        }

                        return pagamento.data;
                        
                    }

                    if(pagamento.data.tipo == "Pagamento de Nota Fiscal Recebida"){

                        pagamento = await this.baixarPagamentoDeNotaFiscalRecebida(pagamentoValores);
                        if(pagamento.status != 200){
                            throw pagamento;
                        }

                        return pagamento.data;
                        
                    }

                    // Se não encontrar o Tipo do Pagamento assuma Erro. 
                    pagamento.status = 500;
                    pagamento.message = "Tipo do Pagamento Invalido";
                    throw pagamento;

                }
            });

        }catch(e){

            console.log(e);
            pagamentos.status = 500;
            return pagamentos;

        }

        return pagamentos;

    },

    async baixarPagamentoDeAdiantamento(pagamentoValores = {}){

        let pagamento = {};

        try{

            //==================================================================//
            //====================== Altera Pagamento ==========================//
            //==================================================================//

            pagamentoValores = {
                id: pagamentoValores.id,
                status: "Pagamento realizado",
                valorParaPagar: 0,
                valorPago: pagamentoValores.valorParaPagar || 0,
            }

            pagamento = await ERP.patchOne(Schema.CONTAS_A_PAGAR_PAGAMENTOS, pagamentoValores);
            if(pagamento.status != 200){
                throw pagamento;
            }

            console.log(pagamento);

            //==================================================================//
            //==================== Pega a Conta a Pagar ========================//
            //==================================================================//

            let contaAPagarID = pagamento.data.contaAPagar;

            let contaAPagar = await ERP.getOneById(Schema.CONTAS_A_PAGAR, contaAPagarID);
            if(contaAPagar.status != 200){
                throw contaAPagar;
            }

            contaAPagar.data.valorParaPagar = contaAPagar.data.valorParaPagar - pagamento.data.valorPago;

            contaAPagar.data.valorPago = contaAPagar.data.valorPago + pagamento.data.valorPago;
            contaAPagar.data.valorParaVincular = contaAPagar.data.valorParaVincular + pagamento.data.valorPago;

            //==================================================================//
            //=================== Altera a Conta a Pagar =======================//
            //==================================================================//

            let contaAPagarValores = {
                id: contaAPagarID,
                valorParaPagar: contaAPagar.data.valorParaPagar,
                valorPago: contaAPagar.data.valorPago,
                valorParaVincular: contaAPagar.data.valorParaVincular,
            }

            contaAPagar = await ERP.patchOne(Schema.CONTAS_A_PAGAR, contaAPagarValores);
            if(contaAPagar.status != 200){
                throw contaAPagar;
            }

            console.log(contaAPagar);

            //==================================================================//
            //================ Cria um Movimento Financeiro ====================//
            //==================================================================//

            let movimentoFinanceiroValores = {
                descricao: contaAPagar?.data?.descricao,
                dataMovimento: UtilDateTime.todayUTC(),
                valorMovimento: pagamento?.data?.valorPago,
                contaFinanceira: CONTA_FINANCEIRA_BANCO_ITAU_DELTA_DUCON_ID,
                contaAPagar: contaAPagar?.data?.id,
                fornecedor: contaAPagar?.data?.favorecidoFornecedor || null,
                colaborador: contaAPagar?.data?.favorecidoColaborador || null,
            }

            let movimentoFinanceiro = await ERP.postOne(Schema.MOVIMENTO_FINANCEIRO, movimentoFinanceiroValores);
            if(movimentoFinanceiro.status != 200){
                throw movimentoFinanceiro;
            }

            console.log(movimentoFinanceiro);

            //==================================================================//
            //=================== Pega a Conta Financeira ======================//
            //==================================================================//

            let contaFinanceira = await ERP.getOneById(Schema.CONTAS_FINANCEIRAS, CONTA_FINANCEIRA_BANCO_ITAU_DELTA_DUCON_ID);
            if(contaFinanceira.status != 200){
                throw contaFinanceira;
            }

            //==================================================================//
            //================= Altera a Conta Financeira ======================//
            //==================================================================//

            contaFinanceira.data.saldo = contaFinanceira?.data?.saldo - pagamento?.data?.valorPago;

            let contaFinanceiraValores = {
                id: contaFinanceira.data.id,
                saldo: contaFinanceira.data.saldo
            }

            contaFinanceira = await ERP.patchOne(Schema.CONTAS_FINANCEIRAS, contaFinanceiraValores);
            if(contaFinanceira.status != 200){
                throw contaFinanceira;
            }

            console.log(contaFinanceira);

        }catch(e){

            console.log(e);
            return pagamento;

        }

        return pagamento;

    },

    async baixarPagamentoDeNotaFiscalRecebida(pagamentoValores = {}){

        let pagamento = {};

        try{

            //==================================================================//
            //====================== Altera Pagamento ==========================//
            //==================================================================//

            pagamentoValores = {
                id: pagamentoValores.id,
                status: "Pagamento realizado",
                valorParaPagar: 0,
                valorPago: pagamentoValores.valorParaPagar || 0,
            }

            pagamento = await ERP.patchOne(Schema.CONTAS_A_PAGAR_PAGAMENTOS, pagamentoValores);
            if(pagamento.status != 200){
                throw pagamento;
            }

            console.log(pagamento);

            //==================================================================//
            //==================== Pega a Conta a Pagar ========================//
            //==================================================================//

            let contaAPagarID = pagamento.data.contaAPagar;

            let contaAPagar = await ERP.getOneById(Schema.CONTAS_A_PAGAR, contaAPagarID);
            if(contaAPagar.status != 200){
                throw contaAPagar;
            }

            contaAPagar.data.valorParaPagar = contaAPagar.data.valorParaPagar - pagamento.data.valorPago;

            contaAPagar.data.valorPago = contaAPagar.data.valorPago + pagamento.data.valorPago;

            //==================================================================//
            //========== Determina se a Conta a Pagar foi Realizada ============//
            //==================================================================//

            if(
                contaAPagar.data.valorParaReservar === 0 &&
                contaAPagar.data.valorParaPagar === 0
            ){

                contaAPagar.data.status = "Realizada"

            }

            //==================================================================//
            //=================== Altera a Conta a Pagar =======================//
            //==================================================================//

            let contaAPagarValores = {
                id: contaAPagarID,
                status: contaAPagar.data.status,
                valorParaPagar: contaAPagar.data.valorParaPagar,
                valorPago: contaAPagar.data.valorPago,
            }

            contaAPagar = await ERP.patchOne(Schema.CONTAS_A_PAGAR, contaAPagarValores);
            if(contaAPagar.status != 200){
                throw contaAPagar;
            }

            console.log(contaAPagar);

            //==================================================================//
            //================== Pega a Nota Fiscal Recebida ===================//
            //==================================================================//

            let notaFiscalRecebidaID = pagamento.data.notaFiscalRecebida;

            let notaFiscalRecebida = await ERP.getOneById(Schema.NOTA_FISCAL_RECEBIDA, notaFiscalRecebidaID);
            if(notaFiscalRecebida.status != 200){
                throw notaFiscalRecebida;
            }

            notaFiscalRecebida.data.valorParaPagar = notaFiscalRecebida.data.valorParaPagar - pagamento.data.valorPago;

            notaFiscalRecebida.data.valorPago = notaFiscalRecebida.data.valorPago + pagamento.data.valorPago;

            //==================================================================//
            //================ Altera a Nota Fiscal Recebida ===================//
            //==================================================================//

            let notaFiscalRecebidaValores = {
                id: notaFiscalRecebidaID,
                valorParaPagar: notaFiscalRecebida.data.valorParaPagar,
                valorPago: notaFiscalRecebida.data.valorPago,
            }

            notaFiscalRecebida = await ERP.patchOne(Schema.NOTA_FISCAL_RECEBIDA, notaFiscalRecebidaValores);
            if(notaFiscalRecebida.status != 200){
                throw notaFiscalRecebida;
            }

            console.log(notaFiscalRecebida);

            //==================================================================//
            //================ Cria um Movimento Financeiro ====================//
            //==================================================================//

            let movimentoFinanceiroValores = {
                descricao: contaAPagar?.data?.descricao,
                dataMovimento: UtilDateTime.todayUTC(),
                valorMovimento: pagamento?.data?.valorPago,
                contaFinanceira: CONTA_FINANCEIRA_BANCO_ITAU_DELTA_DUCON_ID,
                contaAPagar: contaAPagar?.data?.id,
                fornecedor: contaAPagar?.data?.favorecidoFornecedor || null,
                colaborador: contaAPagar?.data?.favorecidoColaborador || null,
            }

            let movimentoFinanceiro = await ERP.postOne(Schema.MOVIMENTO_FINANCEIRO, movimentoFinanceiroValores);
            if(movimentoFinanceiro.status != 200){
                throw movimentoFinanceiro;
            }

            console.log(movimentoFinanceiro);

            //==================================================================//
            //=================== Pega a Conta Financeira ======================//
            //==================================================================//

            let contaFinanceira = await ERP.getOneById(Schema.CONTAS_FINANCEIRAS, CONTA_FINANCEIRA_BANCO_ITAU_DELTA_DUCON_ID);
            if(contaFinanceira.status != 200){
                throw contaFinanceira;
            }

            //==================================================================//
            //================= Altera a Conta Financeira ======================//
            //==================================================================//

            contaFinanceira.data.saldo = contaFinanceira?.data?.saldo - pagamento?.data?.valorPago;

            let contaFinanceiraValores = {
                id: contaFinanceira.data.id,
                saldo: contaFinanceira.data.saldo
            }

            contaFinanceira = await ERP.patchOne(Schema.CONTAS_FINANCEIRAS, contaFinanceiraValores);
            if(contaFinanceira.status != 200){
                throw contaFinanceira;
            }

            console.log(contaFinanceira);

        }catch(e){

            console.log(e);
            return pagamento;

        }

        return pagamento;

    },

}